import { render, staticRenderFns } from "./LuckyHistory.vue?vue&type=template&id=387dca8f&scoped=true&"
import script from "./LuckyHistory.vue?vue&type=script&lang=js&"
export * from "./LuckyHistory.vue?vue&type=script&lang=js&"
import style0 from "./LuckyHistory.vue?vue&type=style&index=0&id=387dca8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387dca8f",
  null
  
)

export default component.exports